import { render } from "./MoveToolsModal.vue?vue&type=template&id=181875b8&scoped=true"
import script from "./MoveToolsModal.vue?vue&type=script&lang=js"
export * from "./MoveToolsModal.vue?vue&type=script&lang=js"

import "./MoveToolsModal.vue?vue&type=style&index=0&id=181875b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-181875b8"]])

export default __exports__